import { Component, OnInit } from '@angular/core';
import { AuthenService } from 'src/app/services/authen.service';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Usuarios } from 'src/app/interfaces/users.interface';
import { MapsService } from 'src/app/services/maps.service';
import { IpsService } from 'src/app/services/ips.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Clinicas } from 'src/app/interfaces/clinica.interface';
import { first, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

declare var google;
declare var $: any;
@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss']
})

export class PrincipalComponent implements OnInit {
nombre
correo
consulta:any=null
geometrias=[]
/***IPS PARAMETROS */
nombreIPS
tipoIPS
nitIPS
departamentoIPS='00'
municipioIPS='00'
departamentoConsulta='00'
municipioIPSConsulta='00'
/**DATOS DE DIRECCION */
direccionIPS
telefonosIPS
nivelIPS
editing=0
  map: any;
  lat;
  lng
  zoom = 18;
  activo=0
  activadorMunicipios: number;
  departamentos;
  coordinates: any;
  departamentosConsulares: Object;
  departamentoConsultante
  clinicasCollection:AngularFirestoreCollection<Clinicas>;
  clnicasObserbavle:Observable<Clinicas[]>;
  clnicasObserbavle2:Observable<Clinicas[]>;
  clinicas=[];
  operar=0;
  operativos=0;
  variable
  visualizar=0;
  totalUsers: number;
  cantidadRecepciones: number;
  recepcionesUnitarias: unknown[];
  recepcionesID: string;
  filterDoc:"";
  visualizarusers=0
  usuariosCollection: AngularFirestoreCollection<Usuarios>;
  usuariosOB: Observable<Usuarios[]>;
  totalClinicax: number;
  year: number;
  uid: string;
  dataset: any[];
  patoListBackup: any;
  patoList: any;
/** */
nombres
direcciones
telefonos
  ids:any;
  niveles: any;
  datasetDepartamentales: any[];
  patoListII: any;
  totalesDepartamentales: number;
/** */

  constructor(private http:HttpClient,private ips:IpsService,private mapService:MapsService,private authen:AuthenService,private db:AngularFirestore,private auth:AngularFireAuth) {
    this.traerInfoPerfil()
    this.totalUsuarios()
    this.obtenerRecepciones()

  
    this.traerUsuarios()
    this.totalClinicas()
    this.darYear()

    
   }

  ngOnInit() {
  }
 
  traerUsuarios(){

    this.usuariosCollection= this.db.collection('usuarios');
    this.usuariosOB=this.usuariosCollection.snapshotChanges().pipe(map(actions => {
    return actions.map(action => {
    const data = action.payload.doc.data() as Usuarios;
    const id = action.payload.doc.id;
   
      return {id, ...data};
    });
    }));
 
  }
  traerInfoPerfil(){
    this.auth.onAuthStateChanged(k=>{
      this.db.collection('usuarios').doc(k.uid).snapshotChanges().subscribe(o=>{
        const data=o.payload.data() as Usuarios
        this.nombre=data.nombre+' '+data.apellido
        this.uid=k.uid
        this.variable="#"+"uid"
        this.correo=k.email
      })
    })
   
  }
  logout(){
    this.authen.logouthin().then(()=>{
       window.location.reload()
    })
  }

  async consultarDireccion(){
    (await this.mapService.consulta(this.direccionIPS)).subscribe(data=>{
      this.consulta=data['results']
      console.log(this.consulta)

    })
    
  
  }
  async crearMapa(lat,lng){
    console.log(lat,lng)
    this.lat=lat
    this.lng=lng    
    

  }
  deleteClinic(i){

    Swal.fire({
      title: 'Estas Seguro de Eliminar Esta Clinica?',
      text: "Recuerda que al eliminarla no podras recuperar el registro",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Eliminar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.db.collection('clinicas').doc(i).delete().then(()=>{
          Swal.fire("Listo!!","Clinica Eliminada","success")
          this.initializeItems()
        })
      }
    })
     
  }
  async subirDatos(nombre,tipo,direccion,latitud,longitud,telefono,nivel,nit,municipioIPS,departamentoIPS){
     this.coordinates={lat:latitud,lng:longitud}
    this.ips.crearIPS(nombre,tipo,direccion,this.coordinates,telefono,nivel,nit,municipioIPS,departamentoIPS).then(()=>{
        this.nombreIPS=null
        this.tipoIPS=null,
        this.direccionIPS=null,
        this.lat=null,
        this.lng=null,
        this.telefonosIPS=null,
        this.nivelIPS=null
        this.consulta=null
        
        this.nitIPS=null
    })
  }

  async subirDatosEps(){
    
  }
  async totalClinicas(){
    this.db.collection('clinicas').valueChanges().subscribe(values=>{
      this.totalClinicax=values.length
    })

  }
  async totalUsuarios(){
    var dataset=[];
    this.db.collection('usuarios').valueChanges().subscribe(values=>{
      this.totalUsers=values.length
    })

      this.db.collection('usuarios').get().subscribe(function(querySnapshot){
      querySnapshot.forEach(doc=>{
        dataset.push([doc.data()['apellido'],doc.data()['nombre'],doc.data()['correo']]);
      })
        $('#solicitantes').DataTable( {
          data: dataset,
          columns: [
            
                  { title: "Apellido" },
                  { title: "Nombre" },
                  {title:"Correo"}
          ], 
          
          language: {
       
            processing: "Procesando...",
            
            
            zeroRecords:    "No se encontraron resultados",
            emptyTable:     "Ningún dato disponible en esta tabla",
            info:           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            infoEmpty:      "Mostrando registros del 0 al 0 de un total de 0 registros",
            infoFiltered:   "(filtrado de un total de _MAX_ registros)",
          
           search:         "Buscar:",
            url:            "",
            loadingRecords: "Cargando...",
            paginate: {
    
               first:    "Primero",
                last:     "Último",
                next:     "Siguiente",
                previous: "Anterior"
            },
          },
    
          "columnDefs": [{
            "defaultContent": "-",
            "targets": "_all"
          }],
                
         
          "scrollY": '350',
          "scrollX": true
        });

      })
    
  }
  async obtenerDepartamentos(code){
 
      
     
      
      
         this.activadorMunicipios=1
         
        
           this.http.get("https://www.datos.gov.co/resource/gdxc-w37w.json?cod_depto="+this.departamentoIPS).subscribe(k=>{
           
           console.log(k)
       
         this.departamentos=k
         console.log(this.departamentos)

         })
    
   }


async obtenerDepartamentosConsulta(code){
 
      
     
      
      
    this.activadorMunicipios=1
    
   
      this.http.get("https://www.datos.gov.co/resource/gdxc-w37w.json?cod_depto="+this.departamentoConsulta).subscribe(k=>{
      
      console.log(k)
  
    this.departamentosConsulares=k
    console.log(this.departamentosConsulares)

    })

}
async obtenerDepartamentosConsultante(code){

  this.datasetDepartamentales=[]
  this.db.collection('clinicas', ref=>ref.where('departamentoIPSs','==',code)).get().subscribe(o=>{
      o.forEach(doc=>{
        this.datasetDepartamentales.push([doc.data()['nombres'],doc.data()['niveles'],doc.data()['direcciones']])

       
       
      })
      this.initializeItemsII()
      $('#departamentales').DataTable( {
        data: this.datasetDepartamentales,
        columns: [
          
                { title: "Nombres" },
                { title: "Niveles" },
                {title:"Direcciones"}
        ], 
        
        language: {
     
          processing: "Procesando...",
          
          
          zeroRecords:    "No se encontraron resultados",
          emptyTable:     "Ningún dato disponible en esta tabla",
          info:           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          infoEmpty:      "Mostrando registros del 0 al 0 de un total de 0 registros",
          infoFiltered:   "(filtrado de un total de _MAX_ registros)",
        
         search:         "Buscar:",
          url:            "",
          loadingRecords: "Cargando...",
          paginate: {
  
             first:    "Primero",
              last:     "Último",
              next:     "Siguiente",
              previous: "Anterior"
          },
        },
  
        "columnDefs": [{
          "defaultContent": "-",
          "targets": "_all"
        }],
              
       
        "scrollY": '350',
        "scrollX": true
      });
  })
}
async obtenerClinicasDepartamentales(){


 this.dataset=[];


      this.db.collection('clinicas',ref=>ref.where('municipioIPSs','==',this.municipioIPSConsulta)).get().subscribe(i=>{
        i.forEach(doc=>{
          this.dataset.push([doc.data()['nombres'],doc.data()['niveles'],doc.data()['direcciones']])
        })
        $('#departamentos').DataTable( {
          data: this.dataset,
          columns: [
            
                  { title: "Nombres" },
                  { title: "Niveles" },
                  {title:"Direcciones"}
          ], 
          
          language: {
       
            processing: "Procesando...",
            
            
            zeroRecords:    "No se encontraron resultados",
            emptyTable:     "Ningún dato disponible en esta tabla",
            info:           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            infoEmpty:      "Mostrando registros del 0 al 0 de un total de 0 registros",
            infoFiltered:   "(filtrado de un total de _MAX_ registros)",
          
           search:         "Buscar:",
            url:            "",
            loadingRecords: "Cargando...",
            paginate: {
    
               first:    "Primero",
                last:     "Último",
                next:     "Siguiente",
                previous: "Anterior"
            },
          },
    
          "columnDefs": [{
            "defaultContent": "-",
            "targets": "_all"
          }],
                
         
          "scrollY": '350',
          "scrollX": true
        });
      })
      

      
    

}
reiniciar(){
  this.dataset=null
 this.departamentoConsulta=null
  this.municipioIPSConsulta=null
  window.location.reload()
}

operationIPS(){
  this.operar=1;
}

operationIPSCancell(){
  this.operar=0;
}

operationIPSVisual(){
  this.visualizar=1;
}
operationIPSVisualCancell(){
  this.visualizar=0;
}
async consultaClinicasTurno(){
 // 


}



operationIPSVisualUsers(){

  this.traerUsuarios()


}
operationIPSVisualCancellUsers(){

}
recepciones(){
  this.operativos=1
}

obtenerRecepciones(){
  this.db.collection('mensajeria').valueChanges().subscribe(data=>{
    this.cantidadRecepciones=data.length
    this.recepcionesUnitarias=data
    this.db.collection('mensajeria').snapshotChanges().subscribe(k=>{
      k.map(b=>{
        const data=b.payload.doc.id

        this.recepcionesID=data
      })
    })
   
  })
}
obtenerClinicas(){
  
  this.db.collection('clinicas',ref=>ref.where('municipioIPSs','==',this.municipioIPSConsulta)).get().subscribe(i=>{
    i.forEach(doc=>{
      this.dataset.push([doc.data()['nombres'],doc.data()['niveles'],doc.data()['direcciones']])
    })
    
  })
  

}

async initializeItems(): Promise<any> {
    
  const patoList = await this.db.collection('clinicas',ref=>ref.where('municipioIPSs','==',this.municipioIPSConsulta))
    .valueChanges().pipe(first()).toPromise();
  this.patoListBackup = patoList;
  console.log(this.patoListBackup)
  this.patoList=patoList
  return patoList;
}

async filterList(event){
  this.patoList = await this.initializeItems();
  const searchTerm = event.srcElement.value;

 
  this.patoList = this.patoList.filter(currentFood => {
    if (currentFood.nombres && searchTerm) {
      return (currentFood.nombres.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
    }
  });
}


async initializeItemsII(): Promise<any> {
    
  const patoList = await this.db.collection('clinicas',ref=>ref.where('departamentoIPSs','==',this.departamentoConsultante))
    .valueChanges().pipe(first()).toPromise();
  this.patoListBackup = patoList;
  console.log(this.patoListBackup)
  this.traerTotales()
  this.patoListII=patoList
  return patoList;
}
traerTotales(){
  this.db.collection('clinicas',ref=>ref.where('departamentoIPSs','==',this.departamentoConsultante)).get().subscribe(o=>{
    this.totalesDepartamentales=o.docs.length
  })
}
clasificacionDepaActiva(){
  if(this.activo==0){
    this.activo=1
  }else{
window.location.reload()
  }
}
clasificacionDepaInactiva(){
alert("hello")
console.log('hello')
}
async filterLista(event){
  this.patoListII = await this.initializeItemsII();
  const searchTerm = event.srcElement.value;

 
  this.patoListII = this.patoListII.filter(currentFood => {
    if (currentFood.nombres && searchTerm) {
      return (currentFood.nombres.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
    }
  });
}
operationRecepcionView(id){
this.db.collection('mensajeria').doc(id).delete().then(()=>{
  Swal.fire("Vista!!","Recepcion vista","success")
})
}
editarRegistro(i){
  this.db.collection('clinicas').doc(i).get().subscribe(l=>{
        this.nombres=l.data()['nombres']
        this.direcciones=l.data()['direcciones']
        this.telefonos=l.data()['telefonos']
        this.niveles=l.data()['niveles']

        this.ids=l.data()['uid']

        console.log(this.nombres)
  })
}

guardarRegistro(){
  this.db.collection('clinicas').doc(this.ids).update({
    nombres:this.nombres,
    direcciones:this.direcciones,
    telefonos:this.telefonos,
   niveles:this.niveles

  }).then(()=>{
    Swal.fire("Cambio Realizado","Cambios guardados","success")
this.initializeItems()
  })
       
}
operativosClaves(){
  this.operativos=0
}
darYear(){
  var date=new Date()
   this.year=date.getFullYear()
}
}
